/* eslint-disable  */
import DataTable from "react-data-table-component";
// import data from './data.json';
import React, { useState, useEffect } from "react";
import { TextField, Button, Modal as MuiModal } from "@mui/material";
import Dashboard from "./Dashboard";
import axios from "axios";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { Container, Stack, SvgIcon } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { remove } from "../library/Api";
import { post } from "../library/Api";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast, ToastContainer } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
//  import { Modal, Button as buttnn ,OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Modal, Radio, Select } from "antd";
// import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import EditForm from "./test_customer";
import PulseLoader from "react-spinners/PulseLoader";
import ScaleLoader from "react-spinners/ScaleLoader";
import SyncLoader from "react-spinners/SyncLoader";
import CustomerEditforms from "./edit_customers";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import UploadIcon from "@mui/icons-material/Upload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { get } from "../library/Api";
import DialogContent from "@mui/material/DialogContent";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons"; // You can use any icon library you prefer
import { ExportOutlined } from "@ant-design/icons";
import DownloadCSV from "./download_csv";
import differenceBy from "lodash/differenceBy";
import deleteIcon from "../assets/images/delete.svg";
import deleteIconBlue from "../assets/images/blue-delete.svg";
import searchIcon from "../assets/images/search.svg";
import attachFileIcon from "../assets/images/attach-square.svg";
import importIcon from "../assets/images/import.svg";
import editIcon from "../assets/images/edit.svg";
import inActiveIcon from "../assets/images/inactive.svg";
import CustomDeleteModal from "./CustomDeleteModal";
import CR_Button from "./Credential Buttons/CR_Button";
import BasicModal from "./Pass_Modal/TempPass_Modal";

const options = [
  { id: '208981', value: 'BB- Rd08:2nd fl Stair', label: 'BB- Rd08:2nd fl Stair' },
  { id: '208982', value: 'BB-Rd01:East Entry Lobby', label: 'BB-Rd01:East Entry Lobby' },
  { id: '208983', value: 'BB-Rd03:Stairs', label: 'BB-Rd03:Stairs' },
  { id: '208984', value: 'Bb-Rd05:Male Restroom', label: 'Bb-Rd05:Male Restroom' },
  { id: '208985', value: 'BB-Rd06:Women Restrooms', label: 'BB-Rd06:Women Restrooms' },
  { id: '208986', value: 'BB-Rd07:Trash Rm', label: 'BB-Rd07:Trash Rm' },
  { id: '208987', value: 'Elev.1 fl2', label: 'Elev.1 fl2' },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  // '& .MuiDialog-paperWidthSm': {
  //   maxWidth: '800',
  // },
  "& .MuiTextField-root": {
    width: "48%",
  },
  // '& .MuiBox-root' : {
  //   textAlign: 'center',
  // },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export function RegisterForms() {
  const [data, setData] = useState([]);
  const [datas, setDatas] = useState([]);
  const [show, setShow] = useState(false);
  const [showdelete, setShowdelete] = useState(false);
  const [showMultidelete, setShowMultidelete] = useState(false);
  const [showdeleteall, setShowdeleteall] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [dupName, setdupName] = useState("");
  const [lastName, setLastName] = useState("");
  const [tableRowsData, setTableRowsData] = useState(datas);
  const [company, setCompany] = useState(datas);
  const [account, setAccount] = useState(datas);
  const [row, setRow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [Download, setDownload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [Upload, setUpload] = useState(false);
  const [failed_data, setfaileddata] = useState("");
  const [exportOption, setexportOption] = useState("All");
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [exportModal, setExportModal] = useState(false);

  const [import_successsCount, setimport_successsCount] = useState("0");
  const [import_totalCount, setimport_totalCount] = useState("0");
  const [import_failCount, setimport_failCount] = useState("0");
  const [failed_csv, setFailed_csv] = useState("");
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [toggleCleared, setToggleCleared] = React.useState(false);
  const [selectablerow, setSelectablerow] = useState(true);
  const [admin_id, setadmin_id] = useState('');
  const [basicModalOpen,setbasicModalOpen] = useState(false);
  //
  // const [show1, setShow1] = useState(false);

  // const handleClose1 = () => setShow1(false);
  // const handleShow1 = () => setShow1(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRfidDeleted, setIsRfidDeleted] = useState(false);
  const [BasicModaloptions, setBasicModalOptions] = useState([]);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id= mcdata.admin_id
    setadmin_id(tempadmin_id)
  }, []);


  const showModal = () => {};
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  //
  const handleRadioChange = (e) => {
    const option = e.target.value;
    setexportOption(option);
    if (option === "All") {
      setSelectedCompany("");
    }
  };




  const onChange = async (e) => {
    // debugger;
    setFirstName(e.target.value);
    setLastName("");
    setCompany("");
    setAccount("");
    // console.log("datas",datas);
    var searchData = datas.filter((item) => {
      // console.log("item",item.firstName);
      if (
        // item?.firstName
        //   .toString()
        //   .toLowerCase()
        //   .includes(e.target.value.toLowerCase())
        JSON.stringify(item)
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) !== -1
      ) {
        return item;
      }
    });

    // console.log(searchData);
    setTableRowsData(searchData);
  };
  const onCancelButtonClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowdelete(false);
    // console.log("called")
  };
  const onCancelButtonClickall = (e) => {
    e.stopPropagation();
    e.preventDefault();
    // setShowdeleteall(false);
    setShowMultidelete(false)
  };
  // const handleOptionChange = (e) =>{
  //  const  selected_comapny = e.target.value
  //  console.log("--------sassa-chin-------------",selected_comapny)
  //  setSelectedCompany(selected_comapny);
  // }

  const handleOptionChange = (selectedValue) => {
    console.log("Selected Company:", selectedValue);
    setSelectedCompany(selectedValue);
  };

  const cancellExportpopUp = () => {
    setExportModal(false);
    setexportOption("All");
  };

  const onConfirmButtonClickdeleteall = (e) => {
    // setShowdeleteall(false);
    setShowMultidelete(false)
    console.log("selectedRows::",selectedRows);
    
    const updatedData = tableRowsData.filter(
      (row) => !selectedRows.includes(row)
    );
    setTableRowsData(updatedData);
    console.log("xsxsxs", selectedRows);
    let ur = "multi_delete_customer";
    let pass_data = {
      admin_id:admin_id,
      data:selectedRows,
      permanent_delete : isRfidDeleted
    }

    post(ur, pass_data).then((response) => {
      console.log("response", response);

      toast.success(`Deleted Sucessfully `, {
        autoClose: 500,
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });
  };
  

  const onConfirmButtonClick = (e) => {
    setShowdelete(false);
    console.log(e);
    
    let pass_data = {
      customer_id: row.customer_id,
      tp_id: row.tp_id,
      admin_id:admin_id,
      tp_credentialid: row.tp_credentialid,
      tp_groupid: row.tp_groupid,
      permanent_delete : isRfidDeleted
    };
    console.log("customer id = is", row.customer_id);
    let ur = "delete_customerdata";
    // let tp = "/".concat(String(row.tp_credentialid)).concat("/").concpost

    post(ur, pass_data).then((response) => {
      console.log("response", response);
      // alert("Deleted", row.customer_id);
      toast.success(`Deleted Sucessfully `, {
        autoClose: 500,
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });
  };

  const onChangelastname = async (e) => {
    debugger;
    setLastName(e.target.value);
    setFirstName("");
    setCompany("");
    setAccount("");
    console.log("datas", datas);
    var searchData = datas.filter((item) => {
      // console.log("item",item.firstName);
      if (
        item?.lastName
          .toString()
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
      ) {
        return item;
      }
    });
    console.log(searchData);
    setTableRowsData(searchData);
  };

  const onChangeaccount = async (e) => {
    debugger;
    setAccount(e.target.value);
    setLastName("");
    setCompany("");
    setFirstName("");
    console.log("datas", datas);
    var searchData = datas.filter((item) => {
      // console.log("item",item.firstName);
      if (
        item?.account
          .toString()
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
      ) {
        return item;
      }
    });

    console.log(searchData);
    setTableRowsData(searchData);
  };
  const onChangecompany = async (e) => {
    debugger;
    setCompany(e.target.value);
    setLastName("");
    setFirstName("");
    setAccount("");
    console.log("datas", datas);
    var searchData = datas.filter((item) => {
      // console.log("item",item.firstName);
      if (
        item?.company
          .toString()
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
      ) {
        return item;
      }
    });
    console.log(searchData);
    setTableRowsData(searchData);
  };
  const handleClose = () => {
    setShow(false);
    setFirstName("");
  };
  const handleEdit = (row) => {
    setRowData(row);
    console.log("here i printing access -- ", row.access_group);
    setShow(true);
  };

  const handleDelete = async (row) => {
    setShowdelete(true);
    setIsRfidDeleted(false)
    setRow(row);
    console.log("rowmmmmmmm", row);
    setdupName(row.firstName);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("--------file-----------", file);
    setSelectedFile(file);
    setSelectedFileName(file ? file.name : "");

    // Handle the selected file as needed
  };
  const handleUpload = () => {
    setUpload(true);
  };

  // const handleRowSelected = React.useCallback(state => {
  //   const selec_rows = state.selectedRows
  //   const tog_f = false

  //   console.log("length of this list",selec_rows.length)
  //   if(selec_rows.length<=5){
  //     setToggleCleared(tog_f);
  // 	  setSelectedRows(selec_rows);
  //   console.log("sachin",selec_rows)
  //   }
  //   if(selec_rows.length>5){
  //     const tog_t = true
  //     setToggleCleared(tog_t);

  //     //   setTimeout(() => {
  //     //     const tog_t = true;
  //     // }, 2000);
  //     // setToggleCleared(false);
  //     toast.error("maximum limit is 5 ")
  //     console.log("sacJose",selec_rows)
  //     console.log("sacJose",tog_t)
  //   }
  // }, []);

  const handleRowSelected = (currentSelectedRows) => {
    setSelectedRows(currentSelectedRows.selectedRows);
  };

  // const handleDeleteSelectedRows = () => {
  const handleMultiDelete = () => {
    if (selectedRows.length > 0 && selectedRows.length <= 5) {
      // setShowdeleteall(true);
      setShowMultidelete(true)
    } else if (selectedRows.length > 5) {
      toast.info(`Please Select Maximum Of 5 Records `, {
        autoClose: 500,
      });
    } else if (selectedRows.length == 0) {
      toast.info(`Please Select Records First `, {
        autoClose: 500,
      });
    }

    // Clear the selected rows state
    // setSelectedRows([]);
  };
  // const contextActions = React.useMemo(() => {
  //   const handleDelete = () => {
  //     console.log("josephk------");

  //     if (
  //       window.confirm(
  //         `Are you sure you want to delete:\r ${selectedRows.map(
  //           (r) => r.firstName
  //         )}?`
  //       )
  //     ) {
  //       setToggleCleared(!toggleCleared);
  //       setTableRowsData(
  //         differenceBy(tableRowsData, selectedRows, "firstName")
  //       );
  //     }
  //   };

  //   return (
  //     <Button
  //       key="delete"
  //       onClick={handleDeleteSelectedRows}
  //       style={{ backgroundColor: "red" }}
  //       icon
  //     >
  //       Delete
  //     </Button>
  //   );
  // }, [tableRowsData, selectedRows]);

  const columns = [
    {
      name: "",
      width: "4rem",
      cell: (row) => (
        <div>
          <a
            href="#"
            className="text-danger"
            onClick={() => {
              handleDelete(row);
            }}
            title="Delete"
            data-toggle="modal"
          >
            <img src={deleteIcon} alt="delete" />
            {/* <DeleteOutlineIcon className="changeFont" /> */}
          </a>
        </div>
      ),
    },
    {
      name: "",
      width: "4rem",
      selector: (row) => (
        <div>
          <a
            href="#"
            onClick={(e) => {
              handleEdit(row);
            }}
            title="Edit"
          >
             <img src={editIcon} alt="Edit" />
            {/* <EditIcon className="changeFont" /> */}
          </a>
        </div>
      ),
    },

    // {
    //   name: (
    //     <div>
    //       <a
    //         href="#"
    //         onClick={(e) => {
    //           handleEdit(row);
    //         }}
    //       >
    //         <EditIcon />
    //       </a>
    //     </div>
    //   ),
    // },

    {
      name: <div>First Name</div>,
      // selector: "firstName",
      selector: (row, i) => row.firstName,
      // cell: (row) => <div>{row.firstName}</div>,
      sortable: true,
      // sortable: true,
      //  cell: row => <div style={{fontSize: 20}}>{row.firstName}</div>
    },

    {
      name: <div>Last Name</div>,
      //  selector: "lastName",
      selector: (row, i) => row.lastName,
      // cell: (row) => <div>{row.lastName}</div>,
      sortable: true,
    },
    {
      name: <div> Email</div>,
      // selector: "email",
      // selector: (row, i) => <div >{row.email}</div>,
      cell: (row) => <div>{row.email}</div>,
      // sortable: true,
    },
    {
      name: <div> Mobile</div>,
      // selector: "mobile",
      selector: (row, i) => <div>{row.mobile}</div>,
      // cell: (row) => <div>{row.mobile}</div>,
    },
    {
      name: <div>Company</div>,
      // width: "10rem",
      // selector: "company",
      selector: (row, i) => row.company,
      sortable: true,
      cell: (row) => <div>{row.company}</div>,
    },

    {
      name: <div>RFID</div>,
      // selector: "rfid",
      selector: (row, i) => <div>{row.rfid}</div>,
      // cell: (row) => <div>{row.rfid}</div>,
    },
    {
      name: <div>No Of Vehicles</div>,
      width: "7rem",
      sortable: true,
      // selector: "vehicles",
      selector: (row, i) => <div>{row.vehicles}</div>,
      // cell: (row) => <div>{row.vehicles}</div>,
    },
    {
      name: <div>Building</div>,
      // selector: "building",
      selector: (row, i) => <div>{row.building}</div>,
      // cell: (row) => <div>{row.building}</div>,
      sortable: true,
    },
    {
      name: <div>Parking Profile</div>,
      width: "6rem",
      // selector: "profile",
      selector: (row, i) => <div>{row.profile}</div>,
      // cell: (row) => <div>{row.profile}</div>,
    },
    {
      name: <div>Garage Address</div>,
      // selector: "garage_address",
      selector: (row, i) => <div>{row.garage_address}</div>,
      // cell: (row) => <div>{row.garage_address}</div>,
    },

    {
      name: <div>Access Group</div>,
      // selector: "access_group",
      // cell: (row) => <div>{row.access_group}</div>,
      selector: (row, i) => (
        <div className="tooltip2" title={`${row.access_group} ${row.room}`}>
          {row.access_group_display}
        </div>
      ),
    },

    // {
    //   name: <div>Flash Account</div>,
    //   // selector: "account",
    //   selector: (row, i) => <div>{row.account}</div>,
    //   // cell: (row) => <div>{row.account}</div>,
    //   // sortable: true,
    // },
  ];

  // onClick={() => {
  //   handleShow(row);}}

  const location = useLocation();
  const navigate = useNavigate();

  const myNewTheme = {
    rows: {
      fontSize: "50px",
    },
  };

  const CreateVisitorPass = ()=>{
    setbasicModalOpen(true)
  }

  const BasicModalClose = () =>{
    setbasicModalOpen(false)
  }

  const HandleClicks = () => {
    if (location.pathname === "/vehicle") {
      navigate("/registers");
    } else {
      navigate("/registers");
    }
  };
  const onClear = () => {
    setFirstName("");
    var searchData = datas;
    setTableRowsData(searchData);
  };
  const handleDownloadClick = () => {
    // setDownload(true);
    // setIsModalOpen(true)

    // if superadmin 
    const temp_mcdata = JSON.parse(localStorage.getItem("MCData"));
    const tm_company = temp_mcdata['company']
    const tm_company_id = temp_mcdata['companyid']

    if (tm_company === 0) {
    setExportModal(true);
    }
    else {
      setSelectedCompany(tm_company_id)
      setexportOption("company_wise")
      setDownload(true)
    }
    // else if (){}
    // else download directly
    // Add any additional logic related to downloading here if needed.
  };

  const confirmDownloadclick = () => {
    if (exportOption === "All") {
      setDownload(true);
      setExportModal(false);
    } else if (exportOption === "company_wise" && selectedCompany) {
      setDownload(true);
      setExportModal(false);
    } else {
      toast.error("Error , Company is Required", {
        autoClose: 500,
      });
    }
  };

  useEffect(() => {
    // Check if Download has changed before initiating the file download
    if (Download) {
      // Initiate the file download for 'exportdata'
      if (exportOption === "All") {
        get("exportdata?type=all", {
          responseType: "blob", // Set the response type to 'blob' for binary data
        })
          .then((fileResponse) => {
            const blob = new Blob([fileResponse.data], {
              type: "application/zip",
            });
            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(blob);
            // Create a temporary anchor element to trigger the download
            const a = document.createElement("a");
            a.href = url;
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1)
              .toString()
              .padStart(2, "0");
            const date = currentDate.getDate().toString().padStart(2, "0");
            const hours = currentDate.getHours().toString().padStart(2, "0");
            const minutes = currentDate
              .getMinutes()
              .toString()
              .padStart(2, "0");
            // const seconds = currentDate.getSeconds().toString().padStart(2, '0');
            // Set the download file name with the formatted date
            const formattedDate = `${year}_${month}_${date}_${hours}_${minutes}`;
            const fileName = `exported_user_data_${formattedDate}.zip`;
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setDownload(false);
            toast.info("Download Completed", {
              autoClose: 500,
            });
          })
          .catch((downloadError) => {
            setDownload(false);
            console.error("Error downloading file:", downloadError);
            toast.error(`Error downloading file `, {
              autoClose: 500,
            });
          });
      }

      if (exportOption === "company_wise") {
        const selected_company_ = selectedCompany;
        const ex_comp_url = "exportdata?type=company&company=".concat(
          selected_company_
        );

        get(ex_comp_url, {
          responseType: "blob", // Set the response type to 'blob' for binary data
        })
          .then((fileResponse) => {
            const blob = new Blob([fileResponse.data], {
              type: "application/zip",
            });
            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(blob);
            // Create a temporary anchor element to trigger the download
            const a = document.createElement("a");
            a.href = url;
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1)
              .toString()
              .padStart(2, "0");
            const date = currentDate.getDate().toString().padStart(2, "0");
            const hours = currentDate.getHours().toString().padStart(2, "0");
            const minutes = currentDate
              .getMinutes()
              .toString()
              .padStart(2, "0");
            // const seconds = currentDate.getSeconds().toString().padStart(2, '0');
            // Set the download file name with the formatted date
            const formattedDate = `${year}_${month}_${date}_${hours}_${minutes}`;
            const fileName = `exported_user_data_${formattedDate}.zip`;
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setDownload(false);

            toast.info("Download Completed", {
              autoClose: 500,
            });
          })
          .catch((downloadError) => {
            setDownload(false);
            console.error("Error downloading file:", downloadError);
            toast.error(`Error downloading file `, {
              autoClose: 500,
            });
          });
      }
      setDownload(false);
    }
  }, [Download]);

  useEffect(() => {
    if (Upload && selectedFile) {
      const Mcdatas = JSON.parse(localStorage.getItem("MCData"));
      const admin_id = Mcdatas.admin_id;
      const admin_company = Mcdatas.company;
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(",")[1]; // Get the base64 portion
        // post start
        post("importdata", {
          file: base64String,
          admin_id: admin_id,
          company_id: admin_company,
        }).then(
          (response) => {
            if (response.status === 200) {
              toast.success("Upload Successfully");
              setUpload(false);
              const success = response.data.successful_inserts;
              const fail_c = response.data.failed_inserts;
              const failcsv = response.data.csv_data_base64;
              const total_c = response.data.total_records;
              setimport_totalCount(total_c);
              setimport_successsCount(success);
              setimport_failCount(fail_c);
              setFailed_csv(failcsv);

              if (fail_c != 0) {
                setIsModalOpen(true);
              }
              console.log();
            } else {
              toast.error(response.data.message);
              setUpload(false);
            }
          },
          (error) => {
            setUpload(false);

            toast.error("Upload Failed", {
              autoClose: 3000,
            });
          }
        );
        // post end
      }; // reader.onload function end

      reader.readAsDataURL(selectedFile);
      // Reset Upload to false after processing
      setUpload(false);
      setSelectedFile(null);
      setSelectedFileName("");
      // window.location.reload();
    }
  }, [Upload]);

  useEffect(() => {
    get(`get_company_list_id`).then((res) => {
      // const data = res;
      setCompanyList(res.data.companies);
      // console.log("companyoooooo", res.data.companies);
    });
  }, []);

  useEffect(() => {}, [tableRowsData]);

  useEffect(() => {
    var data = JSON.parse(localStorage.getItem("MCData"));

    // console.log("ddd", data.admin_id);
    setIsLoading(true);
    if (data?.company == 0) {
      get(`list_customerdata`).then((res) => {
        const data = res;
        
        setData(res.data.data);
        setDatas(
          data?.data?.map((row) => ({
            customer_id: row.customer_id,
            tp_id: row.tp_id,
            tp_credentialid: row.tp_credentialid,
            tp_groupid: row.tp_groupid,
            firstName: row.firstName,
            lastName: row.lastName,
            email: row.email,
            regdate: row.regdate,
            account: row.account,
            company: row.company,
            rfid: row.rfid,
            mobile: row.mobile,
            profile: row.profile,
            building: row.building,
            vehicles: row.vehicles,
            garage_address: row.garage_address,
            access_group: row.access_group,
            room: row.room,
            tp_id: row.tp_id,
            tp_credentialid: row.tp_credentialid,
            tp_groupid: row.tp_groupid,
            access_group_display: row.access_group_display,
          }))
        );
       
        setTableRowsData(
          data?.data?.map((row) => ({
            customer_id: row.customer_id,
            tp_id: row.tp_id,
            tp_credentialid: row.tp_credentialid,
            tp_groupid: row.tp_groupid,
            firstName: row.firstName,
            lastName: row.lastName,
            email: row.email,
            regdate: row.regdate,
            account: row.account,
            mobile: row.mobile,
            company: row.company,
            rfid: row.rfid,
            profile: row.profile,
            building: row.building,
            vehicles: row.vehicles,
            garage_address: row.garage_address,
            access_group: row.access_group,
            room: row.room,
            access_group_display: row.access_group_display,
          }))
        );
     
        setIsLoading(false);
      });
    } else {
      console.log("---------dsas ------------------------------------");
      get(`customers_by_company?company=${data?.companyid}`).then((res) => {
        const data = res;
        
        setData(res.data.data);
        setDatas(
          data.data.map((row) => ({
            customer_id: row.customer_id,
            tp_id: row.tp_id,
            tp_credentialid: row.tp_credentialid,
            tp_groupid: row.tp_groupid,
            firstName: row.firstName,
            lastName: row.lastName,
            email: row.email,
            regdate: row.regdate,
            mobile: row.mobile,
            account: row.account,
            company: row.company,
            rfid: row.rfid,
            profile: row.profile,
            building: row.building,
            vehicles: row.vehicles,
            garage_address: row.garage_address,
            access_group: row.access_group,
            room: row.room,
            access_group_display: row.access_group_display,
          }))
        );
        
        setTableRowsData(
          data.data.map((row) => ({
            customer_id: row.customer_id,
            tp_id: row.tp_id,
            tp_credentialid: row.tp_credentialid,
            tp_groupid: row.tp_groupid,
            firstName: row.firstName,
            lastName: row.lastName,
            email: row.email,
            regdate: row.regdate,
            account: row.account,
            company: row.company,
            rfid: row.rfid,
            profile: row.profile,
            mobile: row.mobile,
            building: row.building,
            vehicles: row.vehicles,
            garage_address: row.garage_address,
            access_group: row.access_group,
            room: row.room,
            access_group_display: row.access_group_display,
          }))
        );
       
        setIsLoading(false);
      });
    }
  }, [show]);

  // Fetch entries from API
  useEffect(() => {
  const fetchGroupsWithEntries = async () => {
    try {
      const res = await get(
        `groups-with-entries?org_id=20767&user_id=8327509`
      );

      if (res?.data?.groups) {
        // store groups for dropdown
        const formattedGroups = res.data.groups.map((g) => ({
          id: g.id,
          value: g.name,
          label: g.name,
        }));
        setGroups(formattedGroups);

        // store all entries tagged with their group
        const formattedEntries = res.data.groups.flatMap((group) =>
          group.entries.map((entry) => ({
            id: String(entry.id),
            value: entry.id,   // or entry.name if you prefer
            label: entry.name,
            group: group.name, // keep track of parent group
          }))
        );
        setBasicModalOptions(formattedEntries);

        console.log("Groups:", formattedGroups);
        console.log("Entries:", formattedEntries);
      }
    } catch (err) {
      console.error("Error fetching groups with entries", err);
    }
  };

  fetchGroupsWithEntries();
}, []);

  // useEffect(() => {
  //   const fetchEntries = async () => {
  //     try {
  //       const response = await get(
  //         'list-entries?org_id=20767'
  //       );

  //       if (response && Array.isArray(response.data.entries)) {
  //         const formattedOptions = response.data.entries.map((entry) => ({
  //           id: String(entry.id),
  //           value: entry.name,
  //           label: entry.name
  //         }));
  //         setBasicModalOptions(formattedOptions);
  //       } else {
  //         console.error('Invalid response format:', response);
  //       }
  //     } catch (error) {
  //       console.error('Failed to fetch entries:', error);
  //     }
  //   };

  //   fetchEntries();
  // }, []);

  const buttonStyle = {
    fontSize: '0.875rem', // Adjust button text size
    padding: '6px 12px', // Adjust button padding for smaller size
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    // padding: '12px 12px',
    borderRadius: '10px',
    bgcolor: 'background.paper',
    boxShadow: 24,
  };

  const handleCheckboxChange = ()=>{
    setIsRfidDeleted(event.target.checked);
  }

  return (
    <>
      <ToastContainer />
      {/* <Navbar name="Dashboard" /> */}
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          {/* <DrawerHeader />
        <Typography paragraph>
        </Typography> */}
          <Modal
            open={showdeleteall}
            title="Delete"
            onOk={onConfirmButtonClickdeleteall}
            onCancel={onCancelButtonClickall}
            footer={[
              <Button key="back" onClick={onCancelButtonClickall}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={onConfirmButtonClickdeleteall}
              >
                Delete
              </Button>,
            ]}
          >
            <p className="text-center">
              Are you sure you want to Delete {row.firstName}?
            </p>
          </Modal>
          {/* <MuiModal
            open={showdelete}
            // title="Delete"
            // onOk={onConfirmButtonClick}
            onCancel={onCancelButtonClick}
            footer={null}
          >
            <Box sx={style}>
          <div 
            style={{ 
              display: 'flex', 
              justifyContent: 'end', 
              alignItems: 'center', 
              padding: '15px',
              position: 'relative',
              width: '100%',
            }}
          > 
          
            <div className="warning-position">
             <img src={inActiveIcon} alt="" className="" style={{width: '70px'}} />
           </div>

            <IconButton size="small" onClick={onCancelButtonClick} >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="modal-wrapper">
            <div className="important-msg">
                  <p>User will be inactivated</p>
            </div>
              <div className="form-check mt-4">
              <input className="form-check-input" type="checkbox" value={isRfidDeleted} id="flexCheckDefault" style={{cursor: 'pointer'}} onChange={handleCheckboxChange}/>
              <label className="form-check-label" for="flexCheckDefault" style={{color: '#00000080', fontSize: '18px'}}>
              Permanently delete RFID card, so that it can be reassigned 
              </label>
            </div>
              <div className="btn-section-modal">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className="me-4 btn-sty w-100 rfid-btn"
                  sx={{ mr: 2, ...buttonStyle }}
                  onClick={onConfirmButtonClick}
                >
                  Inactive
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  className="btn-sty w-100 rfid-btn second"
                  sx={buttonStyle}
                  onClick={onCancelButtonClick}
                >
                  Cancel
                </Button>
                </div>
                <p className="mb-0 notes text-start">
                Note: By deleting RFID you can reuse the RFID
               </p>
            </div>
         </Box>
          </MuiModal> */}

          {/* <MuiModal
            open={showMultidelete}
            onOk={onConfirmButtonClickdeleteall}
            onCancel={onCancelButtonClickall}
            footer={null}
          >
            <Box sx={style}>
          <div 
            style={{ 
              display: 'flex', 
              justifyContent: 'end', 
              alignItems: 'center', 
              padding: '15px',
              position: 'relative',
              width: '100%',
            }}
          > 
          
            <div className="warning-position">
             <img src={inActiveIcon} alt="" className="" style={{width: '70px'}} />
           </div>

            <IconButton size="small" onClick={onCancelButtonClickall} >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="modal-wrapper">
            <div className="important-msg">
                  <p>Users will be inactivated</p>
            </div>
              <div className="form-check mt-4">
              <input className="form-check-input" type="checkbox" value={isRfidDeleted} id="flexCheckDefault" style={{cursor: 'pointer'}} onChange={handleCheckboxChange}/>
              <label className="form-check-label" for="flexCheckDefault" style={{color: '#00000080', fontSize: '18px'}}>
              Permanently delete RFID card, so that it can be reassigned 
              </label>
            </div>
              <div className="btn-section-modal">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className="me-4 btn-sty w-100 rfid-btn"
                  sx={{ mr: 2, ...buttonStyle }}
                  onClick={onConfirmButtonClickdeleteall}
                >
                  Inactive
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  className="btn-sty w-100 rfid-btn second"
                  sx={buttonStyle}
                  onClick={onCancelButtonClickall}
                >
                  Cancel
                </Button>
                </div>
                <p className="mb-0 notes text-start">
                Note: By deleting RFID you can reuse the RFID
               </p>
            </div>
         </Box>
          </MuiModal> */}

        <CustomDeleteModal
          open={showdelete}
          onOk={onConfirmButtonClick}
          onCancel={onCancelButtonClick}
          handleCheckboxChange={handleCheckboxChange}
          style={style}
          isRfidDeleted={isRfidDeleted}
          buttonStyle={buttonStyle}
          message="User will be inactivated"
          />

          <CustomDeleteModal
          open={showMultidelete}
          onOk={onConfirmButtonClickdeleteall}
          onCancel={onCancelButtonClickall}
          handleCheckboxChange={handleCheckboxChange}
          style={style}
          isRfidDeleted={isRfidDeleted}
          buttonStyle={buttonStyle}
          message="Users will be inactivated"
          />


          {/* ------------------------------------------start */}
          {/*  */}
          <Modal open={isModalOpen} onCancel={handleCancel} footer={null}>
            <div
              style={{
                borderRadius: "200px",
                height: "100px",
                width: "100px",
                background: "#1975d114",
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="checkmark"
                style={{
                  color: "#1976d2",
                  fontSize: "50px",
                  lineHeight: "100px",
                  marginLeft: "-15px",
                }}
              >
                ✓
              </i>
            </div>
            <div className="col-md-12 mt-3 mb-4 text-center">
              <p
                style={{
                  fontSize: "25px",
                  fontWeight: "500",
                  color: "#1976d2",
                }}
              >
                Uploaded Successfully
              </p>
            </div>
            <div className="" style={{ margin: "auto", width: "70%" }}>
              {/*  */}
              <div
                class="success-msg px-2 py-3"
                style={{ color: "#1976d2", fontSize: "17px", margin: "auto" }}
              >
                <div className="d-flex align-items-center w-50">
                  <div style={{ width: "200px" }}>
                    <i class="fa fa-check me-2"></i>
                    Total rows
                  </div>
                  <p className="mb-0" style={{ marginLeft: "33px" }}>
                    {import_totalCount}
                  </p>
                </div>
              </div>

              <div
                class="success-msg px-2 py-3"
                style={{ color: "#1976d2", fontSize: "17px", margin: "auto" }}
              >
                <div className="d-flex align-items-center w-50">
                  <div style={{ width: "200px" }}>
                    <i class="fa fa-check me-2"></i>
                    Passed {"    "}
                  </div>
                  <p className="mb-0" style={{ marginLeft: "33px" }}>
                    {import_successsCount}
                  </p>
                </div>
              </div>

              <div
                class="warning-msg px-2 py-3 d-flex align-items-center mb-4"
                style={{
                  color: "#9F6000",
                  fontSize: "17px",
                }}
              >
                <div className="d-flex align-items-center w-50">
                  <div style={{ width: "200px" }}>
                    <i class="fa fa-warning me-2"></i>
                    Failed
                  </div>
                  <p className="mb-0" style={{ marginLeft: "45px" }}>
                    {import_failCount}{" "}
                  </p>
                </div>
                {/* <a href="#" className="d-flex align-items-center" style={{
                      color: '#9f6000',
                      padding: '6px 12px',
                      textDecoration: 'none',
                      fontSize: '20px',
                      border: '1px solid #9f6000',
                      borderRadius: '3px',
                    }}>
                  <ExportOutlined className="" />
                  base64CSV='Rmlyc3QgTmFtZSxMYXN0IE5hbWUsTW9iaWxlLEVtYWlsLENvbXBhbnksUHJvZmlsZSxWZWhpY2xlcyxSRklELEFjY2VzcyBHcm91cCxJZGVudGl0eSBQcm92aWRlcixCdWlsZGluZyxHYXJhZ2UgQWRkcmVzcyxWZWhpY2xlXzEgTWFrZSBhbmQgTW9kZWwsVmVoaWNsZV8xIENvbG9yLFZlaGljbGVfMSBMaWNlbnNlIFBsYXRlLFZlaGljbGVfMSBTdGF0ZSxWZWhpY2xlXzEgUGFya2luZyBTcG90LFZlaGljbGVfMiBNYWtlIGFuZCBNb2RlbCxWZWhpY2xlXzIgQ29sb3IsVmVoaWNsZV8yIExpY2Vuc2UgUGxhdGUsVmVoaWNsZV8yIFN0YXRlLFZlaGljbGVfMiBQYXJraW5nIFNwb3QNCkhhcmksVGVzdDYsMTIzNDU2Nzg5MCxoYXJpdGVzdDI5MTZAZ21haWwuY29tLERjdWJlQWlfMyxMZXZlbCAyLDAsMjk6MjkwNywiQWRtaW4sIEFwYWNoZSIsQXZpZ2lsb24gQWx0YSAvTWNDb3JkIE5hdmlzeXMgR3JvdXAsMjUwIEFzc2F5IFN0cmVldCw3MDcgUmVkZW1wdGlvbiwsLCwsLCwsLCwNCkFiaGlsYXNoLFRlc3Q0LDEyMzQ1Njc4OTAsYWJoaWxhc2h0ZXN0MjkxNEBnbWFpbC5jb20sRGN1YmVBaV8zLExldmVsIDIsMSwyOToyOTA4LEFkbWluLEF2aWdpbG9uIEFsdGEgL01jQ29yZCBOYXZpc3lzIEdyb3VwLDI1MCBBc3NheSBTdHJlZXQsNzA3IFJlZGVtcHRpb24sQk1XLEJsYWNrLERDMDAxMDIsVFgsLCwsLCwNCg=='
                  </a> */}
                <DownloadCSV
                  fileName={"failedentries.csv"}
                  base64CSV={failed_csv}
                />
              </div>

              {/*  */}
            </div>
          </Modal>
          {/*  */}

          {/* ------------------------------------------end */}

          {/* ---------------------start-------------------------------------------------- */}

          <Modal
            className="export-style"
            open={exportModal}
            width={800}
            onCancel={cancellExportpopUp}
            // onOk={handleOk}
            footer={[
              <Button
                onClick={confirmDownloadclick}
                variant="contained"
                style={{ marginLeft: "33px" }}
                key="confirm"
                type="primary"
                className="btn-sty"
              >
                Download
              </Button>,
            ]}
            title=" Export as csv"
          >
            {" "}
            <br />
            <p>Select an option:</p>
            <Radio.Group onChange={handleRadioChange} value={exportOption}>
              <Radio value="All">Export All</Radio>
              <Radio value="company_wise">Export by company</Radio>
            </Radio.Group>
            <br />
            <br />
            {exportOption === "company_wise" && (
              <>
                <p>Select a company :</p>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Select an item"
                  onChange={handleOptionChange}
                  value={selectedCompany}
                >
                  <Select.Option key="" value="">
                    {" "}
                    Please select{" "}
                  </Select.Option>

                  {companyList.map((company) => (
                    <Select.Option
                      key={company.company_id}
                      value={company.company_name}
                      // selected={

                      // }
                    >
                      {company.company_name}
                    </Select.Option>
                  ))}
                </Select>
              </>
            )}
            <br /> <br />
          </Modal>

          <BasicModal
          open={basicModalOpen}
          close={BasicModalClose}
          admin_id={admin_id}
          options={BasicModaloptions}
          optionsgroup={groups}
          />

          {/* ---------------------end-------------------------------------------------- */}

          <div className="App">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3 className="heading-style" style={{fontSize: '1.5rem',
              fontWeight: '500'}}>Customer Details</h3>

              <div className="d-flex align-items-center">
              <div className="tooltip2" title="Delete">
                    <Button
                      className=" text-capitalize"
                      // onClick={handleDeleteSelectedRows}
                      onClick={handleMultiDelete}
                      variant="outlined"
                      style={{
                        padding: "6px 8px",
                        minWidth: "60px",
                        textAlign: "center",
                        borderRadius: "3px",
                        marginRight: "23px",
                        border: "1px solid #1a73cc",
                        cursor: "pointer",
                      }}
                    >
                      {/* <SvgIcon fontSize="medium"> */}
                      <img src={deleteIconBlue} alt="delete" />
                        {/* <DeleteOutlineIcon /> */}
                      {/* </SvgIcon>{" "} */}
                    </Button>
                  </div>
                  <div
                    className="tooltip2"
                    title="Choose csv file to import"
                    style={{
                      textAlign: "center",
                      borderRadius: "3px",
                      marginRight: "23px",
                      border: "1px solid #1a73cc",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="file"
                      id="file-input"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="file-input"
                      style={{
                        padding: "6px 8px",
                        minWidth: "60px",
                        cursor: "pointer",
                      }}
                    >
                        <img src={attachFileIcon} alt="delete" />
                      {/* <AttachFileIcon style={{ color: "#1A71CA" }} /> */}
                    </label>
                    {selectedFileName && (
                      <span style={{ paddingRight: "20px" }}>
                        {selectedFileName}
                      </span>
                    )}
                  </div>
                  <div
                    className="tooltip2"
                    title="Export user data in csv format"
                  >
                    <Button
                      className=" text-capitalize"
                      onClick={handleDownloadClick}
                      // startIcon={
                      //   <SvgIcon fontSize="small">
                      //     <FileDownloadIcon/>
                      //   </SvgIcon>
                      // }
                      variant="outlined"
                      style={{
                        padding: "6px 8px",
                        minWidth: "60px",
                        textAlign: "center",
                        borderRadius: "3px",
                        marginRight: "23px",
                        border: "1px solid #1a73cc",
                        cursor: "pointer",
                      }}
                    >
                      {Download ? (
                        <div>
                          {/* <PulseLoader  
                    size={8}
                    width={2}
                   color="#02487B"
                 /> */}
                          <p style={{ fontWeight: "bold", color: "#02487B" }}>
                            {" "}
                            Download initiated ..{" "}
                          </p>
                        </div>
                      ) : (
                        // <SvgIcon fontSize="medium">
                        //   <FileDownloadIcon />
                        // </SvgIcon>
                        <img src={importIcon} alt="import" />
                      )}
                    </Button>
                  </div>
                <div className="inline position-relative">
                  {firstName ? (
                    <CloseIcon className="search-position" onClick={onClear} />
                  ) : (
                    // <SearchIcon className="search-position" />
                    <img src={searchIcon} alt="search" className="search-position" />
                  )}
                  {/* <CloseIcon className="search-position" /> */}

                  {/* --------------start---------------- */}
                  
                  
                  {selectedFileName ? (
                    <div className="tooltip2 me-2" title="Import users">
                      <Button
                        className=" text-capitalize"
                        onClick={handleUpload}
                        variant="outlined"
                        style={{
                          padding: "6px 8px",
                          minWidth: "60px",
                          textAlign: "center",
                          borderRadius: "3px",
                          marginRight: "23px",
                          border: "1px solid #1a73cc",
                          cursor: "pointer",
                        }}
                      >
                        <SvgIcon fontSize="medium">
                          <FileUploadIcon />
                        </SvgIcon>{" "}
                        Import
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}

                  {/* -------------- end ------------------ */}

                  

                  <input
                    type="text"
                    placeholder="Search by Name,Company"
                    value={firstName}
                    onChange={(e) => onChange(e)}
                    style={{ width: "290px" }}
                    className="me-4 search-style"
                  />
                </div>
                <Box display="flex" gap={2}>
                <Button
                  className="btn-sty text-capitalize"
                  onClick={HandleClicks}
                  startIcon={
                    <SvgIcon fontSize="small">
                      <PlusIcon />
                    </SvgIcon>
                  }
                  variant="contained"
                >
                  Create Customer
                </Button>
                {admin_id == 1 ?
                <CR_Button
                buttonText={'Create Visitor Pass'}
                btnClick={CreateVisitorPass}
                />:<></>
                }
                </Box>
              </div>
            </div>

            <div className="">
              {isLoading ? (
                <div
                  className="table-style"
                  style={{ marginLeft: "46%", marginTop: "20%" }}
                >
                  <PulseLoader
                    color="#02487B"
                    height={29}
                    margin={4}
                    radius={24}
                    width={4}
                  />
                  <p style={{ fontWeight: "bold", color: "#02487B" }}>
                    {" "}
                    Loading{" "}
                  </p>
                </div>
              ) : (
                <div className="table-cover">
                <DataTable
                  title="  "
                  columns={columns}
                  data={tableRowsData}
                  highlightOnHover
                  customTheme={myNewTheme}
                  pagination
                  selectableRows={true}
                  // contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  // fixedHeader
                  // selectableRowsVisibleOnly={false}
                  options={{
                    disableSelectionOnClick: true,
                    noHeader: true
                  }}
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[15, 30, 50, 100]}
                  paginationComponentOptions={{
                    rowsPerPageText: "Records per page:",
                    rangeSeparatorText: "out of",
                  }}
                  className="table-style "
                />
                </div>
              )}
            </div>
          </div>
          <div></div>
        </Box>
      </Box>

      {rowData && (
        <div>
          <BootstrapDialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
            className="m-0 w-100"
            fullScreen
          >
            <BootstrapDialogTitle
              id="customized-dialog-title"
              className="heading-style bg-gray"
              onClose={handleClose}
            >
              {"Edit Customer"}
            </BootstrapDialogTitle>
            <DialogContent>
              {/* {console.log("------fpage cust id-------->>",rowData.customer_id)}{ console.log("--0-0---0-0-",rowData)} */}
              <CustomerEditforms theEmployee={rowData} theEmployees={show}  onClose={handleClose}/>
              {/* <EditForm theEmployee={rowData} /> */}
            </DialogContent>
            {/* <DialogActions>
          <Button autoFocus  className="btn-sty "onClick={handleClose}>Close</Button>
          </DialogActions> */}
          </BootstrapDialog>
        </div>
      )}
    </>
  );
}

export default RegisterForms;
